import router from './router'
import store from './store'
import {
    getToken,
    getEnterToken
} from '@/utils/auth'
import APP from '@/utils/base'
import Util from '@/utils/util'

const whiteList = ['/login']
let flag = false
router.beforeEach(async (to, from, next) => {
    if (to.path === '/person' || to.path === '/index') {
        let _text = APP.fnGetUrlParams()
        if (_text) {
            // let _info = APP.fnAesDecrypt(_text.project)
            let _info = decodeURIComponent(window.atob(decodeURIComponent(_text.project)))
            Util.fnSetLoginInfo(_info)
        }
    }
    const hasToken = getToken()
    const hasEnter = getEnterToken()

    if (hasToken) {
        if (to.path === '/login') {
            next('/')
        } else {
            const regionId = await store.dispatch('getRegionId')

            // 刷新时需重新添加路由
            if (flag === false) {
                store.dispatch('generateRoutes', regionId).then(res => {
                    router.addRoutes(res)
                    flag = true
                    next({ ...to,
                        replace: true
                    })
                })
            } else {
                next()
            }
        }
    } else {
        if (hasEnter) {
            if (to.path === '/enter' || to.path === '/login') {
                next()
            } else {
                next({
                    path: '/enter'
                })
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) {
                next()
            } else {
                next({
                    path: '/login?direction=' + from.path
                })
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/permission.js